/** Unicode 16.0.0 ranges matching common/identity.py::_name_letter.
 * Regenerate when that classifier changes; Script=Latin alone also admits
 * ordinal/modifier symbols that the server intentionally rejects. */
export const identityLetterRanges: readonly (readonly [number, number])[] = [
  [0x41, 0x5a],
  [0x61, 0x7a],
  [0xc0, 0xd6],
  [0xd8, 0xf6],
  [0xf8, 0x2af],
  [0x1d00, 0x1d25],
  [0x1d62, 0x1d65],
  [0x1d6b, 0x1d77],
  [0x1d79, 0x1d9a],
  [0x1e00, 0x1eff],
  [0x2090, 0x209c],
  [0x2184, 0x2184],
  [0x2c60, 0x2c7c],
  [0x2c7e, 0x2c7f],
  [0x3041, 0x3096],
  [0x30a1, 0x30fa],
  [0x31f0, 0x31ff],
  [0xa722, 0xa76f],
  [0xa771, 0xa787],
  [0xa78b, 0xa7cd],
  [0xa7d0, 0xa7d1],
  [0xa7d3, 0xa7d3],
  [0xa7d5, 0xa7dc],
  [0xa7f5, 0xa7f7],
  [0xa7fa, 0xa7ff],
  [0xab30, 0xab5a],
  [0xab60, 0xab64],
  [0xab66, 0xab68],
  [0xfb00, 0xfb06],
  [0x1aff0, 0x1aff3],
  [0x1aff5, 0x1affb],
  [0x1affd, 0x1affe],
  [0x1b000, 0x1b001],
  [0x1b11f, 0x1b122],
  [0x1b132, 0x1b132],
  [0x1b150, 0x1b152],
  [0x1b155, 0x1b155],
  [0x1b164, 0x1b167],
  [0x1df00, 0x1df1e],
  [0x1df25, 0x1df2a],
]
